<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="900px"
    :title="'出库单附件下载'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :amzFtyNoticeOutCode="amzFtyNoticeOutCode"
      @close="close"
      @download="download"
    />
  </el-dialog>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    amzFtyNoticeOutCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    download({ fileCode }) {
      if (!fileCode) return
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>
